import React, { createContext, useContext, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import AuthService from '../../services/AuthService';

const AuthContext = createContext(null);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [admin, setAdmin] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    // Vérifier l'authentification au chargement
    const checkAuth = () => {
      const authenticated = AuthService.isAuthenticated();
      setIsAuthenticated(authenticated);
      if (authenticated) {
        setAdmin(AuthService.getAdmin());
        AuthService.setupAxiosInterceptors();
      }
      setIsLoading(false);
    };
    checkAuth();
  }, []);

  const login = async (email, password) => {
    const result = await AuthService.login(email, password);
    if (result.success) {
      setIsAuthenticated(true);
      setAdmin(result.administrator);
      AuthService.setupAxiosInterceptors();
      navigate('/');
    }
    return result;
  };

  const logout = () => {
    AuthService.logout();
    setIsAuthenticated(false);
    setAdmin(null);
    navigate('/login');
  };

  const value = {
    admin,
    isAuthenticated,
    isLoading,
    login,
    logout,
    accessToken: AuthService.getAccessToken()
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;
